export default "__VITE_ASSET__BolsU8zo__"